import React from "react";
import PublicationHeader from "../component/PublicationHeader";
export default function Publications() {
  return (
    <div>
      <PublicationHeader/>
    </div>
  );
}
